<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="cancel()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Create Button</v-toolbar-title>
        </v-toolbar>
        <v-form v-model="valid" @submit="save" ref="createButtonForm" onsubmit="return false">
            <v-card-text>
                <v-dialog v-model="eventDialog">
                    <v-data-table
                            :headers="headers"
                            :items="cadEventTypes"
                            :items-per-page="50"
                            class="elevation-1">
                        <template v-slot:item.actions="{item}">
                            <v-btn icon v-on:click="selectCadEventType(item.code)"><v-icon dark>mdi-pencil</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-dialog>
                <v-container fluid>
                    <v-layout>
                        <v-flex md3 sm12>
                            <v-text-field label="Label"
                                          ref="buttonLabel"
                                          :rules="serverValidation('label','Label')"
                                          v-model="button.label"
                                          counter="100"
                            ></v-text-field>
                        </v-flex>
                        <v-flex md3 sm12>
                            <v-select :items="buttonTypes"
                                      label="Event Type"
                                      item-text="description"
                                      v-model="button.eventType"
                                      :rules="serverValidation('eventType','Event Type')"
                                      item-value="code"></v-select>
                        </v-flex>
                        <v-flex md3 sm12>
                            <v-select :items="buttonIndexes"
                                      label="Display Order"
                                      v-model="button.displayOrder"
                                      :rules="serverValidation('Display Order','Display Order')"
                                      ></v-select>
                        </v-flex>
                        <v-flex md3 sm12>
                            <v-text-field label="CAD Event Type"
                                          v-model="button.cadEventType"
                                          :rules="serverValidation('cadEventType','CAD Event Type')"
                                          counter="100"
                                          append-icon="mdi-magnify"
                                          @click:append="getCadEvents()"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex md12>
                            <v-text-field label="Incident Text"
                                          v-model="button.incidentText"
                                          :rules="serverValidation('incidentText','Incident Text')"
                                          counter="100"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex md4 sm12>
                            <v-checkbox label="Send Message"
                                        v-model="button.sendSms"
                            ></v-checkbox>
                        </v-flex>
                        <v-flex md4 sm12>
                            <v-checkbox label="Dial Emergency"
                                        v-model="button.dialEmergency"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex md12>
                                <v-text-field label="Message Text"
                                              v-model="button.smsText"
                                              :rules="serverValidation('smsText','SMS Text')"
                                              counter="100"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex md12>
                            <v-select v-model="button.contactLists"
                                        label="Contact Lists To Notify"
                                        multiple
                                        chips
                                        :rules="serverValidation('contactLists','Contacts')"
                                        :items="contacts"
                                        item-text="name"
                                        item-value="id"
                                        persistent-hint
                                        deletable-chips
                                        append-icon="mdi-magnify"
                                        @click:append="viewContacts()"></v-select>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn outlined type="button" @click="cancel()" color="warning" :disabled="overlay">Cancel</v-btn>
                <v-btn outlined type="submit" color="success" :disabled="overlay">Save</v-btn>
                <v-progress-circular
                        :width="3"
                        v-show="overlay"
                        color="red"
                        indeterminate="">
                </v-progress-circular>
            </v-card-actions>
        </v-form>
        <v-dialog v-model="contactDialog">
            <v-card>
                <v-card-title>Contacts</v-card-title>
                <v-card-text>
                    <p>The Following People Will Be Contacted Based On the Selected Lists</p>
                    <ul>
                        <li v-for="contact in contactDialogContent">
                            {{contact}}
                        </li>
                    </ul>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat text color="success" @click="contactDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>

    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'

    export default {
        mixins:[validationMixin],
        data() {
            return {
                headers: [
                    {'text':'Code','value':'code'},
                    {'text':'Description','value':'description'},
                    {'text':'Actions','value':'actions'}
                ],
                buttonIndexes : [],
                eventDialog:false,
                cadEventTypes:[],
                overlay: false,
                valid: false,
                button: {},
                buttonTypes : [],
                profileId : null,
                organizationId : null,
                contacts : [],
                contactDialog : false,
                contactDialogContent:[]
            }
        },
        mounted() {
            this.buttonTypes = api.constants.BUTTON_TYPES;
        },
        methods: {
            open(profileId, organizationId) {
                this.reset();
                this.profileId = profileId;
                this.organizationId = organizationId;
                this.$root.$emit('showGlobalOverlay');
                api.profile.buttonIndexes.get(this.profileId).then((data) => {
                    this.buttonIndexes = data;
                    api.contactList.search({
                        organizationId : this.organizationId
                    }).then((data) => {
                        this.contacts = data.list;
                        this.$root.$emit('hideGlobalOverlay');
                        this.$nextTick(this.$refs.buttonLabel.focus);
                    });

                });
            },
            reset() {
                this.profileId = null;
                this.organizationId = null;
                this.overlay = false;
                this.valid = false;
                this.button = {};
                this.violations = [];
            },
            viewContacts() {
                this.contactDialogContent = [];
                if (!this.button.contactLists || this.button.contactLists.length == 0) {
                    return;
                }
                const contactArr = [];
                let promises = [];
                this.button.contactLists.forEach((id) => {
                    promises.push(new Promise((resolve,reject) => {
                        api.contactList.get(id).then((cl) => {
                            if (cl.contacts && cl.contacts.length > 0) {
                                cl.contacts.forEach((clc) => {
                                    contactArr.push(clc.name + ' - ' + clc.phoneNumber);
                                });
                            }

                            if (cl.users && cl.users.length > 0) {
                                cl.users.forEach((clu) => {
                                    contactArr.push(clu.name + ' - ' + clu.phoneNumber);
                                });
                            }
                            resolve();
                        });
                    }));
                });

                Promise.all(promises).then(() => {
                    this.contactDialogContent = contactArr;
                    this.contactDialog = true;
                }).catch((e) => {
                    this.$root.$emit('globalError','Error Loading Contact List');
                });


            },
            getCadEvents() {
                this.$root.$emit('showGlobalOverlay')
                api.profile.eventTypes.get(this.profileId).then((data) => {
                    this.cadEventTypes = data;
                    this.eventDialog = true;
                }).catch(() => {
                    this.$root.$emit('globalError','Error Fetching CAD Event Types. Please Test CAD Connection');
                }).finally(() => {
                    this.$root.$emit('hideGlobalOverlay')
                });
            },
            selectCadEventType(code) {
                this.cadEventTypes = [];
                this.eventDialog = false;
                this.button.cadEventType = code;
            },
            phoneInput() {
                var b;
                if (this.button.smsNumbers) {
                    for (var i=0;i<this.button.smsNumbers.length;i++) {
                       b = this.button.smsNumbers[i];
                       b = b.replace(/\D/g,'');
                       if (b.length > 10) {
                           b = b.substring(0,9);
                       }
                       this.button.smsNumbers[i] = b;
                    }
                }

            },
            save() {
                this.button.profileId = this.profileId;
                api.button.post(this.button).then((button) => {
                    this.reset();
                    this.$emit('saved',button);
                    this.$root.$emit('globalMessage','Button Saved');
                }, (error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.createButtonForm.validate();
                    }
                });
            },
            cancel() {
                this.$emit('cancelled');
            }
        }
    }

</script>